import { render, staticRenderFns } from "./ModalNextStepQuestionary.vue?vue&type=template&id=52e470fc&scoped=true&"
import script from "./ModalNextStepQuestionary.vue?vue&type=script&lang=js&"
export * from "./ModalNextStepQuestionary.vue?vue&type=script&lang=js&"
import style0 from "./ModalNextStepQuestionary.vue?vue&type=style&index=0&id=52e470fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e470fc",
  null
  
)

export default component.exports